module.exports = __webpack_public_path__ + "img/under_construction.d72d146e.svg";